import {
  ScheduledNotificationStatus,
} from '@shared/enums/ScheduledNotificationStatus';
import { useTranslation } from 'react-i18next';

export const useNotificationStatusLabel = (): Record<ScheduledNotificationStatus, string> => {
  const { t } = useTranslation();
  return {
    [ScheduledNotificationStatus.Draft]:
      t(($) => $.notificationBuilder.statuses.draft),
    [ScheduledNotificationStatus.Scheduled]:
      t(($) => $.notificationBuilder.statuses.scheduled),
    [ScheduledNotificationStatus.Sent]:
      t(($) => $.notificationBuilder.statuses.sent),
    [ScheduledNotificationStatus.Cancelled]:
      t(($) => $.notificationBuilder.statuses.cancelled),
  };
};
